import request from "@/utils/request";

/**
 * 微信登录
 * @param {*} code 
 * @returns 
 */
export function authorize(code) {
	return request(
		{
			method: 'POST',
			url: "/mp/authorize",
			params: { code }
		})
}

/**
 * 获取房源详情
 * @param {String|Number} id 
 * @returns 
 */
export function getHouserDetailById(id = '7027108255750946816', clientId = '') {
	return request(
		{
			url: `/mp/estates/${id}`,
			method: "GET",
			params: { clientId: clientId }
		})
}
export function getnewHouserDetailById(id = '7027108255750946816', clientId = '') {
	return request(
		{
			url: `/mp/estates/wxshare/${id}`,
			method: "GET",
			params: { clientId: clientId }
		})
}

/**
 * 获取微信配置信息
 * @param {*} url 
 * @returns 
 */
export function getWxJsApi(url) {
	return request(
		{
			url: "/mp/jsapi",
			method: "GET",
			params: { url }
		})
}
export function newtypeapi(url) {
	return request(
		{
			url: "/pay/myNotify",
			method: "GET",
			params: { url }
		})
}

/**
 * 获取推荐列表
 * @param {*} data 
 * @returns 
 */
export function getRecommend(params) {
	return request(
		{
			url: "/mp/recommend",
			method: "GET",
			params
		})
}

// 读取所有区域
export const areasList = (statistics = 'false') => {
	return request(
		{
			url: '/shops/areas',
			method: 'get',
			params: { statistics }
		})
}
// 读取所有区域 用户端
export const newareasList = (statistics = 'false', extraParams = {}) => {
	return request(
		{
			url: '/api/customer/areas',
			method: 'get',
			params: { statistics, ...extraParams }
		})
}
/**
 * /mp/transactions/{id}/pay
 */
export function transactionsPay(id) {
	return request(
		{
			url: `/mp/transactions/${id}/pay`,
			method: "POST"
		})
}
export function zjin(id) {
	return request(
		{
			url: `/mp/recharge_record/${id}/pay`,
			method: "POST"
		})
}

export const getCommunity = params => {
	return request(
		{
			url: '/shops/communities',
			params,
		})
}
export const newgetCommunity = params => {
	return request(
		{
			url: '/api/customer/communities',
			params,
		})
}

/**
 * 获取房源列表
 * @param {*} params
 * @returns
 */
export function getResourcesList(params) {
	return request(
		{
			method: 'GET',
			url: '/shops/estates',
			params,
		})
}
export function newgetResourcesList(params) {
	return request(
		{
			method: 'GET',
			url: '/api/customer/estates',
			params,
		})
}
/**
 * shops/schools
 * 获取学区列表
 */
export function getSchoolsList(params) {
	// '/shops/schools', "GET", params
	return request(
		{
			method: 'GET',
			url: '/shops/schools',
			params,
		})
}

/**
 * /flats/detail
 * @param {*} params 
 */
export function getFlatsDetail(flatsId) {
	return request(
		{
			method: 'GET',
			url: `/mp/flats/${flatsId}`,
		})
}

/**
 * // 添加楼盘访问量
 * /flats/visitor/add
 */
export function addFlatsVisit(data) {
	return request(
		{
			method: 'POST',
			url: '/flats/visitor/add',
			data,
		})
}

/**
 * 获取小区详情
 * @returns /shops/communities
 */
export function getCommunitiesById(id) {
	return request(
		{
			method: "GET",
			url: `/shops/communities/${id}`
		})
}
/**
 * /mp/files
 * 上传文件
 */
export function mpUploadFiles(data) {
	return request(
		{
			url: "/mp/files",
			method: "POST",
			data
		})
}


/**
 * /flats/findArea
 */
export function flatsFindAreaList(data) {
	return request(
		{
			url: "/flats/findFLats",
			method: "POST",
			data
		})
}

/**
 * /mp/shop-service-orders/{id}/pay
 * 支付门店订单 门店续费
 */
export function mpShopServiceOrderPay(id) {
	return request(
		{
			url: `/mp/shop-service-orders/${id}/pay`,
			method: "POST"
		})
}

/**
 * /stations
 */
export function getStations() {
	return request(
		{
			url: "/stations",
			method: "GET"
		})
}